import httpClient from "http-client/http-client";
import { normalizePhoneNumber, sendSignupOtp } from "./signup.service";

export { normalizePhoneNumber } from "./signup.service";

export async function sendLoginOtp(phoneNumber) {
  return sendSignupOtp(phoneNumber, "LOGIN");
}

export async function loginPortal({ phone_number, otp }) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/auth/login",
    body: {
      phone_number: normalizePhoneNumber(phone_number),
      otp: String(otp || "").trim(),
    },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function selectAccount({ account_id, selection_token }) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/auth/select-account",
    body: { account_id },
    headers: { Authorization: `Bearer ${selection_token}` },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function listAccessibleAccounts() {
  const { data, errors } = await httpClient.get({
    url: "v1/community-portal/auth/accessible-accounts",
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function switchAccount({ account_id }) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/auth/switch-account",
    body: { account_id },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function logoutPortal() {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/auth/logout",
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
